require('./adapters/rest-adapter')
